import React from "react";
import ButtonBase from "@mui/material/ButtonBase";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import AddIcon from "@mui/icons-material/Add";
import CircularProgress from "@mui/material/CircularProgress";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";

export default function MoreOptionsMenu({ onAddNewKit, creating }) {
  const handleAddNewKit = async popupState => {
    if (onAddNewKit) await onAddNewKit();
    popupState.close();
  };

  return (
    <PopupState variant="popover" popupId="kitting-more-options">
      {popupState => (
        <>
          <ButtonBase aria-label="more options" {...bindTrigger(popupState)}>
            {creating ? <CircularProgress size={18} sx={{ mr: 0.5 }} /> : <MoreVertIcon />} More
            Options
          </ButtonBase>
          <Menu id="kitting-more-options" {...bindMenu(popupState)}>
            <MenuItem onClick={() => handleAddNewKit(popupState)}>
              <ListItemIcon>
                <AddIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Add New Kit" />
            </MenuItem>
          </Menu>
        </>
      )}
    </PopupState>
  );
}


